
import * as React from 'react';
import { fluentSvgIconStyles } from '../../../../styles/iconStyles';

export const FlowDot20Regular: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
    return <svg role="img" focusable="false" aria-hidden viewBox="0 0 20 20" width={20} height={20} fill="currentColor" className={props.className} style={{ ...props.style, ...fluentSvgIconStyles }} onClick={props.onClick}>
        <path
            d="M5 2.5A2 2 0 0 1 6.93 4H14a3 3 0 1 1 0 6H6a2 2 0 1 0 0 4h7.07a2 2 0 1 1 0 1H6a3 3 0 1 1 0-6h8a2 2 0 1 0 0-4H6.93A2 2 0 1 1 5 2.5Z"
            fill="currentColor"
        />
    </svg>
}